import { render, staticRenderFns } from "./AddMenuItemsAsOptions.vue?vue&type=template&id=1ab512ea&scoped=true"
import script from "./AddMenuItemsAsOptions.vue?vue&type=script&lang=js"
export * from "./AddMenuItemsAsOptions.vue?vue&type=script&lang=js"
import style0 from "./AddMenuItemsAsOptions.vue?vue&type=style&index=0&id=1ab512ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab512ea",
  null
  
)

export default component.exports